import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { getProjects } from '../services/project/service';
import { EncryptedObjectIdString } from '../types/common';
import { ProjectDto } from '../types/dto/project';
import { withSimpleFormApiErrorHandling } from '../utils/simpleForm/handleSimpleFormApiError';
import { useResource } from './useResource';

const projectsByEncryptedSimpleFormIdMap = new Map<
    EncryptedObjectIdString,
    ProjectDto[]
>();

export const useProjects = () => {
    const navigate = useNavigate();

    const { fetchResource } = useResource<
        {
            encryptedSimpleFormId: EncryptedObjectIdString;
        },
        ProjectDto[]
    >({
        fetchFn: getProjects,
        cacheMap: projectsByEncryptedSimpleFormIdMap,
        getCacheKey: ({ encryptedSimpleFormId }) => encryptedSimpleFormId,
    });

    const fetchProjects = useCallback(
        (params: { encryptedSimpleFormId: EncryptedObjectIdString }) =>
            withSimpleFormApiErrorHandling(
                () => fetchResource(params),
                navigate,
            ),
        [fetchResource, navigate],
    );

    return { fetchProjects };
};
